import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';

const useStyles = makeStyles({
  dialog: {
    padding: '15px',
    paddingBottom: '0px'
  }
});

interface Props {
  alerts: any;
  alertAction: Function;
  clearAlerts: Function;
}

interface DynamicButton {
  type: string;
  label: string;
  onClick: any;
}

export default function ProblemPartsPopup(props: Props) {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [buttons, setButtons] = React.useState<Array<DynamicButton>>([]);
  const classes = useStyles();

  React.useEffect(() => {
    // Display alerts and then clear them
    let alertString = '';
    let actions: Array<DynamicButton> = [];

    // Prevent duplicates
    let actionsTaken: {[key: string]: boolean} = {};
    
    props.alerts.forEach((alert: any, i: number) => {
      const space = i > 0 ? '<br />' : '';
      alertString += space + alert.get('message');
    
      // Alert has an action attached to it
      // Assign a button if it doesn't already have one
      if (typeof alert.get('actions') !== 'undefined' && alert.get('actions').count() > 0) {
        alert.get('actions').forEach((action: any) => {
          if (typeof action.get('action') !== 'undefined' && action.get('action') != '' && typeof actionsTaken[action.get('type')] === 'undefined') {
            actionsTaken[action.get('type')] = true;
            const method = action.get('method') ? action.get('method') : 'GET';
            actions.push({
              type: action.get('type'),
              onClick: () => {
                props.alertAction(action.get('action'), action.get('data').toJS(), method, () => setOpen(false));
              },
              label: action.get('label')
            });
          }
        });
      }
    });

    if (props.alerts.size > 0) {
      setOpen(true);
    }

    setMessage(alertString);
    setButtons(actions);
  }, [props.alerts.size]);

  function handleClose() {
    setOpen(false);
    props.clearAlerts();
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <div className={classes.dialog}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">Close</Button>
        {buttons.map((button) => (
          <Button 
            key={button.type} 
            onClick={button.onClick}
          >
            {button.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}